// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Importacion paleta de colores */
:root {
  --text-light:#9E9E9E;
  --text-medium:#4D4D4D;
  --text-dark:#0F0F0F;
  --text-heading: #001733;
  --text-link: #0F69B4;
  --primary-00: #0F69B4;
  --primary-10: #F2F8FF;
  --primary-20: #D6E9FF;
  --primary-40: #66A7EB;
  --primary-60: #093F6C;
  --primary-80: #001733;
  --secondary-00: #E22C2C;
  --secondary-20: #FFCCCC;
  --secondary-40: #FF6666;
  --secondary-80: #330000;
  --background-primary: #FEFDFD;
  --background-secondary: #0D223F;
  --icon-light:#9E9E9E;
  --icon-dark:#0F69B4;
  --neutral-00: #FFFFFF;
  --neutral-05: #EFEFEF;
  --neutral-10: #DFDFDF;
  --neutral-20: #BEBEBE;
  --neutral-40: #9E9E9E;
  --neutral-60: #4D4D4D;
  --neutral-80: #0F0F0F;
  --success-light: #EFF8EF;
  --success-medium: #92DF92;
  --success-dark: #5CB85C;
  --success-opacitie: #5CB85C 20%;
  --error-light: #FBEEED;
  --error-medium: #F98885;
  --error-dark: #D9534F;
  --error-opacitie: #D9534F 20%;
  --warning-light: #FFF6E8;
  --warning-medium: #FFCB66;
  --warning-dark: #FFA11B;
  --warning-opacitie: #FFA11B 20%;
  --information-light: #EFF9FC;
  --information-medium: #8DE2FB;
  --information-dark: #5BC0DE;
  --information-opacitie: #5BC0DE 20%;
  --dark-05:#0000000D;
  --dark-10:#0000001A;
  --dark-20:#00000033;
  --dark-40:#00000066;
  --dark-80:#000000CC;
  --light-05:#FFFFFF0D;
  --light-10:#FFFFFF1A;
  --light-20:#FFFFFF33;
  --light-40:#FFFFFF66;
  --light-80:#FFFFFFCC;
  --shadow-soft: 0px 2px 2px 0px rgba(77, 77, 77, 0.15);
  --shadow-medium: 0px 4px 8px 0px rgba(77, 77, 77, 0.15);
  --shadow-strong: 0px 8px 16px 0px rgba(77, 77, 77, 0.15);
}

/* Reset de estilos para mejorar la consistencia entre navegadores */
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
font,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font-family: "Roboto";
  vertical-align: baseline;
}

/* Estilos cuerpo del documento */
body {
  font-family: "Roboto";
  font-style: normal;
  color: var(--text-medium) !important;
}

/* Estilos para contenedores */
.principal {
  min-height: 30vw;
  border-radius: 20px;
}

/* Estilos para encabezados */
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "PT Sans", sans-serif;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-family: Roboto Slab;
  color: var(--text-medium) !important;
}

@media screen and (max-width: 768.98px) {
  h1 {
    font-size: 1.75rem !important;
  }
  h2 {
    font-size: 1.5rem !important;
  }
  h3 {
    font-size: 1.37rem !important;
  }
  h4 {
    font-size: 1rem !important;
  }
  h5 {
    font-size: 0.87rem !important;
  }
  h6 {
    font-size: 0.72rem !important;
  }
}
@media screen and (min-width: 769px) {
  h1 {
    font-size: 2rem !important;
  }
  h2 {
    font-size: 1.75rem !important;
  }
  h3 {
    font-size: 1.5rem !important;
  }
  h4 {
    font-size: 1.37rem !important;
  }
  h5 {
    font-size: 1rem !important;
  }
  h6 {
    font-size: 0.87rem !important;
  }
}
/* Estilos para textos */
.fontTitulo {
  font-family: Roboto Slab;
  font-size: 32px !important;
  font-style: normal;
  font-weight: 700;
  line-height: 2.81rem;
  letter-spacing: 0em;
  text-align: left;
}

.fontSubtitulo {
  font-family: Roboto Slab;
  font-size: 1.625rem !important;
  font-style: normal;
  font-weight: 700;
  line-height: 2.125rem;
  letter-spacing: 0em;
  text-align: left;
  margin-top: 2rem;
}

/* Estilo para barra bajo titulo */
.title-underline {
  height: 0.25rem;
  border-radius: 0.25rem;
  margin-bottom: 1.5rem;
}

/* Estilos Texto botones */
.ant-btn > span {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.001em;
  text-align: center;
}

.capitalizar {
  text-transform: capitalize;
}

/* Estilos para boton link */
.buttonLink {
  background: none !important;
  border: none;
  color: var(--primary-00);
}

.buttonLink:hover {
  text-decoration: underline;
  cursor: pointer;
  color: var(--primary-00);
}

/* Estilos fix antd */
.ant-message-info .anticon-info-circle svg {
  margin-top: -6px;
}

.anticon-question-circle svg {
  margin-top: -7px;
}

.anticon-exclamation-circle svg {
  margin-top: -7px;
}

span.ant-table-column-title {
  font-weight: 100;
}

/* Media queries para layouts establecidos en Bootstrap */
@media screen and (min-width: 1200px) and (max-width: 1399.98px) {
  .principal {
    max-width: 80%;
  }
}
@media screen and (min-width: 1400px) {
  .principal {
    max-width: 86%;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/globalStyle.scss","webpack://./src/styles/paleta-colores.scss"],"names":[],"mappings":"AAAA,kCAAA;ACAA;EAEI,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EAGA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EAGA,6BAAA;EACA,+BAAA;EAGA,oBAAA;EACA,mBAAA;EAGA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,wBAAA;EACA,yBAAA;EACA,uBAAA;EACA,+BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,6BAAA;EACA,wBAAA;EACA,yBAAA;EACA,uBAAA;EACA,+BAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;EACA,mCAAA;EAGA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EAIA,qDAAA;EACA,uDAAA;EACA,wDAAA;ADhBJ;;AAtDA,oEAAA;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAkFE,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,qBAAA;EACA,wBAAA;AAyDF;;AAtDA,iCAAA;AACA;EACE,qBAAA;EACA,kBAAA;EACA,oCAAA;AAyDF;;AAtDA,8BAAA;AACA;EACE,gBAAA;EACA,mBAAA;AAyDF;;AAtDA,6BAAA;AACA;;;;;;EAME,kCAAA;EACA,wIAAA;EAEA,wBAAA;EACA,oCAAA;AAwDF;;AArDA;EACE;IACE,6BAAA;EAwDF;EAtDA;IACE,4BAAA;EAwDF;EAtDA;IACE,6BAAA;EAwDF;EAtDA;IACE,0BAAA;EAwDF;EAtDA;IACE,6BAAA;EAwDF;EAtDA;IACE,6BAAA;EAwDF;AACF;AArDA;EACE;IACE,0BAAA;EAuDF;EArDA;IACE,6BAAA;EAuDF;EArDA;IACE,4BAAA;EAuDF;EArDA;IACE,6BAAA;EAuDF;EArDA;IACE,0BAAA;EAuDF;EArDA;IACE,6BAAA;EAuDF;AACF;AApDA,wBAAA;AACA;EACE,wBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;AAsDF;;AAnDA;EACE,wBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAsDF;;AAnDA,kCAAA;AACA;EACE,eAAA;EACA,sBAAA;EACA,qBAAA;AAsDF;;AAnDA,0BAAA;AACA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;AAsDF;;AAnDA;EACE,0BAAA;AAsDF;;AAnDA,4BAAA;AAEA;EACE,2BAAA;EACA,YAAA;EACA,wBAAA;AAqDF;;AAlDA;EACE,0BAAA;EACA,eAAA;EACA,wBAAA;AAqDF;;AAlDA,qBAAA;AAEA;EACE,gBAAA;AAoDF;;AAjDA;EACE,gBAAA;AAoDF;;AAjDA;EACE,gBAAA;AAoDF;;AAjDA;EACE,gBAAA;AAoDF;;AAjDA,yDAAA;AAeA;EACE;IACE,cAAA;EAsCF;AACF;AAnCA;EACE;IACE,cAAA;EAqCF;AACF","sourcesContent":["/* Importacion paleta de colores */\n@import \"./paleta-colores.scss\";\n\n/* Reset de estilos para mejorar la consistencia entre navegadores */\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nfont,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font-family: \"Roboto\";\n  vertical-align: baseline;\n}\n\n/* Estilos cuerpo del documento */\nbody {\n  font-family: \"Roboto\";\n  font-style: normal;\n  color: var(--text-medium) !important;\n}\n\n/* Estilos para contenedores */\n.principal {\n  min-height: 30vw;\n  border-radius: 20px;\n}\n\n/* Estilos para encabezados */\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"PT Sans\", sans-serif;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen,\n    Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-family: Roboto Slab;\n  color: var(--text-medium) !important;\n}\n\n@media screen and (max-width: 768.98px) {\n  h1 {\n    font-size: 1.75rem !important;\n  }\n  h2 {\n    font-size: 1.5rem !important;\n  }\n  h3 {\n    font-size: 1.37rem !important;\n  }\n  h4 {\n    font-size: 1rem !important;\n  }\n  h5 {\n    font-size: 0.87rem !important;\n  }\n  h6 {\n    font-size: 0.72rem !important;\n  }\n}\n\n@media screen and (min-width: 769px) {\n  h1 {\n    font-size: 2rem !important;\n  }\n  h2 {\n    font-size: 1.75rem !important;\n  }\n  h3 {\n    font-size: 1.5rem !important;\n  }\n  h4 {\n    font-size: 1.37rem !important;\n  }\n  h5 {\n    font-size: 1rem !important;\n  }\n  h6 {\n    font-size: 0.87rem !important;\n  }\n}\n\n/* Estilos para textos */\n.fontTitulo {\n  font-family: Roboto Slab;\n  font-size: 32px !important;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 2.81rem;\n  letter-spacing: 0em;\n  text-align: left;\n}\n\n.fontSubtitulo {\n  font-family: Roboto Slab;\n  font-size: 1.625rem !important;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 2.125rem;\n  letter-spacing: 0em;\n  text-align: left;\n  margin-top: 2rem;\n}\n\n/* Estilo para barra bajo titulo */\n.title-underline {\n  height: 0.25rem;\n  border-radius: 0.25rem;\n  margin-bottom: 1.5rem;\n}\n\n/* Estilos Texto botones */\n.ant-btn > span {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  letter-spacing: 0.001em;\n  text-align: center;\n}\n\n.capitalizar {\n  text-transform: capitalize;\n}\n\n/* Estilos para boton link */\n\n.buttonLink {\n  background: none !important;\n  border: none;\n  color: var(--primary-00);\n}\n\n.buttonLink:hover {\n  text-decoration: underline;\n  cursor: pointer;\n  color: var(--primary-00);\n}\n\n/* Estilos fix antd */\n\n.ant-message-info .anticon-info-circle svg {\n  margin-top: -6px;\n}\n\n.anticon-question-circle svg {\n  margin-top: -7px;\n}\n\n.anticon-exclamation-circle svg {\n  margin-top: -7px;\n}\n\nspan.ant-table-column-title {\n  font-weight: 100;\n}\n\n/* Media queries para layouts establecidos en Bootstrap */\n\n//XS\n@media screen and (max-width: 575.98px) {\n}\n//SM\n@media screen and (min-width: 576px) and (max-width: 767.98px) {\n}\n//MD\n@media screen and (min-width: 768px) and (max-width: 991.98px) {\n}\n//LG\n@media screen and (min-width: 992px) and (max-width: 1199.98px) {\n}\n//XL\n@media screen and (min-width: 1200px) and (max-width: 1399.98px) {\n  .principal {\n    max-width: 80%;\n  }\n}\n//XXL\n@media screen and (min-width: 1400px) {\n  .principal {\n    max-width: 86%;\n  }\n}\n",":root {\n    //Texts\n    --text-light:#9E9E9E;\n    --text-medium:#4D4D4D;\n    --text-dark:#0F0F0F;\n    --text-heading: #001733;\n    --text-link: #0F69B4;\n\n    //main colors\n    --primary-00: #0F69B4;\n    --primary-10: #F2F8FF;\n    --primary-20: #D6E9FF;\n    --primary-40: #66A7EB;\n    --primary-60: #093F6C;\n    --primary-80: #001733;\n\n    //secondary colors\n    --secondary-00: #E22C2C;\n    --secondary-20: #FFCCCC;\n    --secondary-40: #FF6666;\n    --secondary-80: #330000;\n\n    //background colors\n    --background-primary: #FEFDFD;\n    --background-secondary: #0D223F;\n\n    //icons\n    --icon-light:#9E9E9E;\n    --icon-dark:#0F69B4;\n\n    //neutral colors\n    --neutral-00: #FFFFFF;\n    --neutral-05: #EFEFEF;\n    --neutral-10: #DFDFDF;\n    --neutral-20: #BEBEBE;\n    --neutral-40: #9E9E9E;\n    --neutral-60: #4D4D4D;\n    --neutral-80: #0F0F0F;\n\n    //Feedback colors\n    --success-light: #EFF8EF;\n    --success-medium: #92DF92;\n    --success-dark: #5CB85C;\n    --success-opacitie: #5CB85C 20%;\n    --error-light: #FBEEED;\n    --error-medium: #F98885;\n    --error-dark: #D9534F;\n    --error-opacitie: #D9534F 20%;\n    --warning-light: #FFF6E8;\n    --warning-medium: #FFCB66;\n    --warning-dark: #FFA11B;\n    --warning-opacitie: #FFA11B 20%;\n    --information-light: #EFF9FC;\n    --information-medium: #8DE2FB;\n    --information-dark: #5BC0DE;\n    --information-opacitie: #5BC0DE 20%;\n\n    //Opacities\n    --dark-05:#0000000D;\n    --dark-10:#0000001A;\n    --dark-20:#00000033;\n    --dark-40:#00000066;\n    --dark-80:#000000CC;\n    --light-05:#FFFFFF0D;\n    --light-10:#FFFFFF1A;\n    --light-20:#FFFFFF33;\n    --light-40:#FFFFFF66;\n    --light-80:#FFFFFFCC;\n\n\n    //Shadows\n    --shadow-soft: 0px 2px 2px 0px rgba(77, 77, 77, 0.15);\n    --shadow-medium: 0px 4px 8px 0px rgba(77, 77, 77, 0.15);\n    --shadow-strong: 0px 8px 16px 0px rgba(77, 77, 77, 0.15);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
